module.exports = __webpack_public_path__ + "img/bg.1f87d525.png";